import React from 'react';
import NavBar from '../../../Shared/NavBar/NavBar';

const Header = () => {

    return (
        <div className='text-white relative bg-gradient-to-b from-slate-800 to-transparent'>
            <NavBar />
        </div>
    );
};

export default Header;